import { project_name, send_error_msg } from "./settings";
import { store } from "./store/store";


export function KASapiAuth() {
    return fetch(process.env.REACT_APP_KAS_BACKADDR + '/users/auth', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `username=${process.env.REACT_APP_KAS_USERNAME}&password=${process.env.REACT_APP_KAS_PASS}`
    })
}

export function logError(message: string) {
    
    const accessToken =  store.getState().app.accessToken;

    if (send_error_msg)
        return fetch(`${process.env.REACT_APP_KAS_BACKADDR}users/send_message?project_name=${project_name}&text=${message}`, {
            method: 'GET',
            headers: {
                'Authorization': `bearer ${accessToken}`
            },
    })
    throw new Error(message);
}